import React from 'react';
import PropTypes from 'prop-types';

import MReferenceList from '../molecules/_molecules.reference-list';

export default function OReference({ items, className }) {
	let list = [];

	if (items && items.length) {
		list = 	<MReferenceList items={items} />;
	}

	return (
		<section className={`o-reference-list ${className}`}>
			{list}
		</section>
	);
}

OReference.propTypes = {
	items: PropTypes.array.isRequired,
	className: PropTypes.string,
};

OReference.defaultProps = {
	className: '',
};




// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.reference.js